import { render, staticRenderFns } from "./TransferSubscriptions.vue?vue&type=template&id=c1f7d912&scoped=true&"
import script from "./TransferSubscriptions.vue?vue&type=script&lang=ts&"
export * from "./TransferSubscriptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f7d912",
  null
  
)

export default component.exports